/**
 * Client for the leadership summary (release 8, C6). Wire shape mirrors
 * apps/api-controller/src/modules/discovery/leadership-summary.ts.
 */

import { apiFetch } from './api';

export type Block<T> =
  | { available: true; data: T }
  | { available: false; reason: 'not_permitted' | 'no_history' | 'not_yet_run' | 'unavailable' };

export interface LeadershipSummary {
  generatedAt: string;
  riskTrend: Block<{
    range: 30;
    fromDay: string;
    toDay: string;
    openThen: number;
    openNow: number;
    openChange: number;
    riskScoreChange: number | null;
    historyStartsOn: string | null;
  }>;
  auditChain: Block<{ status: 'intact' | 'broken'; verifiedAt: string; blocksScanned: number; brokenAtBlockIndex: number | null }>;
  breaches: Block<{ notYetNotified: number; draft: number; acknowledged: number }>;
  unreadable: Block<{ encryptedFiles: number; storesWithEncrypted: number; storesReported: number; storesSeparatingEncrypted: number }>;
  /** The top stores by data points (rows x personal columns). */
  densest: Block<{
    stores: Array<{ name: string; sourceType: string; density: number; personalColumns: number; columnsKnown: number; dataPoints: number | null }>;
    measuredStores: number;
    unmeasuredStores: number;
  }>;
}

export function getLeadershipSummary(): Promise<LeadershipSummary> {
  return apiFetch('/v1/discovery/leadership-summary');
}
